import {
  buildURL,
  isListenLabsHostname,
  type BuildUrlSearchParams,
} from "@/utils/helpers";

export const INTERVIEW_LINK_PREFIX = "/i";
// Links minted before the move to /i/ keep resolving on this route.
export const LEGACY_INTERVIEW_LINK_PREFIX = "/s";
export const INTERVIEW_LINK_PREFIXES = [
  INTERVIEW_LINK_PREFIX,
  LEGACY_INTERVIEW_LINK_PREFIX,
] as const;

export const getInterviewPath = (linkId: string): string =>
  `${INTERVIEW_LINK_PREFIX}/${linkId}`;

export const buildInterviewUrl = ({
  linkId,
  searchParams,
}: {
  linkId: string;
  searchParams?: BuildUrlSearchParams;
}): string => buildURL({ path: getInterviewPath(linkId), searchParams });

/** Study participant links on a Listen Labs host, on either interview route. */
export const isListenLabsStudyLink = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    const isStudyPath = INTERVIEW_LINK_PREFIXES.some((prefix) =>
      parsed.pathname.startsWith(`${prefix}/`)
    );
    return isListenLabsHostname(parsed.hostname) && isStudyPath;
  } catch {
    return false;
  }
};
